'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref, _ref2) {
  var rank = _ref.rank,
      styles = _ref.styles,
      subtitle = _ref.subtitle;
  var measures = _ref2.measures,
      rhythm = _ref2.rhythm,
      scale = _ref2.scale;

  var defaultStyles = {
    root: {
      display: 'block',
      position: 'relative',
      minHeight: rhythm(2),
      padding: rhythm(0.33) + ' ' + rhythm(0.33) + ' ' + rhythm(0.33) + ' ' + rhythm(rank ? 2 : 0.33),
      fontSize: scale(-1),
      breakInside: 'avoid',
      listStyle: 'none'
    },

    rank: {
      position: 'absolute',
      top: '50%',
      left: rhythm(0.5),
      height: rhythm(2),
      lineHeight: rhythm(2),
      marginTop: rhythm(-1)
    },

    link: {
      display: 'flex',
      alignItems: 'center',
      transition: 'opacity 200ms ease',
      minHeight: rhythm(1.33),
      '&:hover': {
        opacity: 0.75
      }
    },

    image: {
      flex: '0 0 auto',
      width: rhythm(1.25),
      height: rhythm(1.25),
      backgroundColor: 'rgba(0,0,0,0.125)',
      border: '2px solid rgba(0,0,0,0.25)',
      borderRadius: '50%',
      marginRight: rhythm(0.5)
    },

    info: {
      flex: 1,
      minWidth: 0
    },

    title: {
      marginBottom: subtitle && rhythm(0.125),
      fontWeight: 700,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },

    subtitle: {
      lineHeight: measures.medium,
      fontSize: '0.75em',
      opacity: 0.7,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },

    amount: {
      flex: '0 0 auto',
      paddingLeft: rhythm(0.5),
      paddingRight: rhythm(0.5),
      textAlign: 'right',
      lineHeight: measures.medium
    }
  };

  return (0, _merge2.default)(defaultStyles, styles);
};


//////////////////
// WEBPACK FOOTER
// ../~/constructicon/leaderboard-item/styles.js
// module id = 851
// module chunks = 0